// @flow
export { default } from './SearchForm';
export * from './config/forms.config';
export type { FieldsetConfig } from './FieldConfig';
export type { SearchFormValue } from './SearchForm';



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/index.js